import { forwardRef, useEffect } from "react";
import { serverUrl } from "../../../data/dataApi";
import { handleSendFeedback, feedbackReasons, unexpectedError } from "../../helpers";

const FeedbackModal = forwardRef((props, ref) => {
    const { 
        isOpen,
        onOpen,
        onChange,
        feedbackDetails,
        disabled,
        error,
        messageKey,
        sessionInfo,
        onError,
        onSuccess,
        onUpdate,
        onDisable,
        success,
        messages,
        userEmail
    } = props;
    // const [additionalSupportAccordionOpen, setAdditionalSupportAccordionOpen] = useState(false);

    const handleCheckFeedback = async e => {
        e.preventDefault();

        onError("");
        onSuccess(false);

        if (!feedbackDetails.content) {
            onError("Please provide details about the issue with the response.");
        } else {
            try {
                const data = await handleSendFeedback(messages, sessionInfo, "down", feedbackDetails, messageKey, userEmail);

                if (data.error) {
                    onError(unexpectedError);
                } else if (data.success) {
                    onSuccess(true);
                    onUpdate(prevState => ([
                        ...prevState.map((message, index) => {
                            if (index === messageKey) {
                                message.rating = "down";
                            }

                            return message;
                        }),
                    ]));
                    onDisable(true);
                }
            } catch (error) {
                onError(unexpectedError);
            }
        }
    };

    const handleFeedbackReasonUpdate = reason => {
        if (feedbackDetails.reason.includes(reason)) {
            onChange(prevState => ({ ...prevState, reason: prevState.reason.filter(item => item !== reason) }));
        } else {
            onChange(prevState => ({ ...prevState, reason: [...prevState.reason, reason] }));
        }
    };

    useEffect(() => {
        onDisable(false);
        onSuccess(false);
        onError("");
    }, [isOpen]);

    return (
        <div id="feedback-modal" className={`position-fixed top-0 w-100 h-100 tif-px-15 start-0 overflow-y-auto ${isOpen ? 'open' : ''}`}>
            <div className="modal-container" ref={ref}>
                <div className="modal-header">
                    <p className="modal-title"><img src={`${serverUrl}/static/assets/thumb-down-red-icon.svg`} alt="Thumb down red icon" />Provide Additional Feedback</p>
                    <button className="modal-close-btn" onClick={() => onOpen(false)}><img src={`${serverUrl}/static/assets/close-icon.svg`} alt="Close icon" /></button>
                </div>
                <div className="modal-content">
                    <form id="feedback-form" onSubmit={handleCheckFeedback}>
                        <textarea placeholder="What was the issue with the response? How could it be improved?" value={feedbackDetails.content} onChange={e => onChange(prevState => ({ ...prevState, content: e.target.value }))}></textarea>

                        {
                            feedbackReasons.map((reason, index) => (
                                <div className="checkbox-outer" key={index}>
                                    <div className="checkbox-wrapper">
                                        <input type="checkbox" id={`${reason.id}-checkbox`} checked={feedbackDetails.reason.includes(reason.title)} onChange={() => handleFeedbackReasonUpdate(reason.title)} />
                                        <label htmlFor={`${reason.id}-checkbox`} className="checkbox"></label>
                                    </div>
                                    <label htmlFor={`${reason.id}-checkbox`} className="checkbox-label">{reason.title}</label>
                                </div>
                            ))
                        }

                        <button type="submit" className="secondary-btn" disabled={disabled}>Submit</button>
                        {
                            error &&
                            <p className="error-text">{ error }</p>
                        }
                        {
                            success &&
                            <p className="success-text">Feedback successfully submitted.</p>
                        }
                    </form>

                    {/* <div className={`additional-support-wrapper ${additionalSupportAccordionOpen ? "show" : ""}`}>
                        <div className="additional-support-header" onClick={() => setAdditionalSupportAccordionOpen(prevState => !prevState)}>
                            <div className="additional-support-header-wrapper">
                                <p className="additional-support-header-title">Need additional support?</p>
                                {additionalSupportAccordionOpen && <p className="additional-support-header-subtitle">Call <b>888.734.8344</b> to talk to customer support or request an email back below.</p>}
                            </div>
                            <div className="additional-support-header-icon-wrapper">
                                <img src={`${serverUrl}/static/assets/up-caret-icon.svg`} alt="Up caret icon" />
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
});

export default FeedbackModal;